module.exports = __webpack_public_path__ + "img/湖北大学.70ce2d9d.png";